<div class="table-container">
  <p-table
    [value]="data"
    [class]="'custom-table' + (context === 'letters' ? ' letters-table' : '')"
    [tableStyle]="{ 'min-width': '100%' }"
    [loading]="loading"
  >
    <!-- Header -->
    <ng-template pTemplate="header">
      <tr>
        @for (column of columns; track column.key) {
        <th
          [class]="
            getHeaderClass(column) + ' ' + getColumnWidthClass(column.key)
          "
        >
          {{ column.label }}
        </th>
        } @if (context !== 'letters') {
        <th></th>
        } @else {
        <th></th>
        }
      </tr>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-row>
      <tr [class.cursor-pointer]="context !== 'users'" (click)="context !== 'users' ? onRowClick(row) : null">
        @for (column of columns; track column.key) {
        <td [class]="getColumnWidthClass(column.key)">
          @if ((column.key === 'name' || column.key === 'fullName') &&
          row.avatar) {
          <div class="flex items-center gap-3">
            <div
              class="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white text-sm font-medium"
            >
              {{ row.avatar }}
            </div>
            <span class="font-medium text-gray-900">{{ row[column.key] }}</span>
          </div>
          } @else if (column.key === 'isActive') {
          <span [class]="row[column.key] ? 'text-green-600' : 'text-red-600'">
            {{ row[column.key] ? row.statusText || "Active" : "Inactive" }}
          </span>
          } @else if (column.key === 'status' && row.hasOwnProperty('status')) {
          @if (context === 'users') {
          <div class="flex items-center gap-3">
            @if (isArchivedView) {
            <!-- Show "Archived" text for archived users -->
            <span class="text-sm text-gray-500 italic">Archived</span>
            } @else {
            <!-- Show toggle switch for active users -->
            <p-toggleSwitch
              [ngModel]="row[column.key] === 'Active'"
              (onChange)="onStatusToggle(row, $event)"
              [class]="'status-toggle'"
            ></p-toggleSwitch>
            }
          </div>
          } @else if ((context === 'letters' || context === 'routing-slip') && isArchivedView) {
          <!-- Show "Archived" text for archived letters or routing slips -->
          <div class="flex items-center gap-2">
            <div class="w-2 h-2 rounded-full bg-gray-500"></div>
            <span class="text-xs text-gray-700 font-[Montserrat]">Archived</span>
          </div>
          } @else {
          <div class="flex items-center gap-2">
            <div
              class="w-2 h-2 rounded-full"
              [class]="getStatusColor(row[column.key])"
            ></div>
            <span class="text-xs text-gray-700 font-[Montserrat]">{{
              row[column.key]
            }}</span>
          </div>
          } } @else if (column.key === 'approvalStatus') {
          <div class="flex items-center gap-2">
            <div
              class="w-2 h-2 rounded-full"
              [class]="getStatusColor(row[column.key])"
            ></div>
            <span class="text-xs text-gray-700 font-[Montserrat]">{{
              row[column.key] || "-"
            }}</span>
          </div>
          } @else if (isDateColumn(column.key)) {
          <!-- Format date columns using the date utility -->
          <span class="text-xs text-gray-700 font-[Montserrat]">{{
            formatDate(row[column.key])
          }}</span>
          } @else if (column.key === 'documentName') {
          <!-- Hyperlinked document name for routing slips -->
          <span
            class="text-blue-600 hover:text-blue-800 underline cursor-pointer text-xs font-semibold font-[Montserrat]"
            (click)="onDocumentNameClick(row); $event.stopPropagation()"
          >
            {{ row[column.key] }}
          </span>
          } @else {
          {{ row[column.key] }}
          }
        </td>
        }

        <td>
          @if (shouldShowReplyButton) {
          <!-- Reply button for managers in letters context -->
          <button
            type="button"
            class="flex items-center gap-2 reply-button"
            (click)="onReply(row); $event.stopPropagation()"
          >
            <i class="pi pi-reply"></i>
            <span class="underline">Reply</span>
          </button>
          } @else if (shouldShowActionMenu) {
          <!-- Action menu for secretary and admin roles in letters context -->
          <app-action-menu
            [row]="row"
            [context]="context"
            [getPermissionForRow]="getPermissionForRow"
            (viewClick)="onRowClick($event)"
            (auditLog)="onAuditLog($event)"
            (approve)="onApprove($event)"
            (reject)="onReject($event)"
            (comment)="onComment($event)"
            (edit)="onEdit($event)"
            (delete)="onDelete($event)"
            (reply)="onReply($event)"
            (click)="$event.stopPropagation()"
          >
          </app-action-menu>
          } @else if ((context === 'users' || context === 'letters' || context === 'routing-slip') && isArchivedView) {
          <!-- No actions for archived users, letters, or routing slips -->
          <span class="text-xs text-gray-500 italic">No actions available</span>
          } @else {
          <!-- Action menu for other contexts (non-letters) -->
          <app-action-menu
            [row]="row"
            [context]="context"
            [getPermissionForRow]="getPermissionForRow"
            (viewClick)="onRowClick($event)"
            (auditLog)="onAuditLog($event)"
            (approve)="onApprove($event)"
            (reject)="onReject($event)"
            (comment)="onComment($event)"
            (edit)="onEdit($event)"
            (delete)="onDelete($event)"
            (reply)="onReply($event)"
            (click)="$event.stopPropagation()"
          >
          </app-action-menu>
          }
        </td>
      </tr>
    </ng-template>
    <!-- Audit Log Modal -->

    <app-audit-modal
      [(visible)]="auditDialogVisible"
      [title]="'Audit Log'"
      [row]="selectedRow"
      [logs]="auditData"
      (close)="closeAuditLog()"
    >
    </app-audit-modal>

    <!-- Empty State -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length + 2" class="text-center empty-state-cell">
          @if (loading) { Loading... } @else { No Data Available }
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
